import { useEffect, useState } from 'react';
import api from '../api';
import { QUALITY_SERVICE_API_URL } from '../config';

/**
 * Aggregates for the Stats tab. Computed over the FULL bug population, not the rows the table
 * happens to be showing — the table is flagged bugs only, and adding those up client-side would
 * understate every number.
 */
export default function useDuplicateStats() {
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const controller = new AbortController();

    api.get(`${QUALITY_SERVICE_API_URL}/hub/duplicates/stats`, { signal: controller.signal })
      .then(res => {
        setStats(res.data);
        setError(null);
        setLoading(false);
      })
      .catch(err => {
        if (err.code === 'ERR_CANCELED') return;
        setError(err);
        setLoading(false);
      });

    return () => controller.abort();
  }, []);

  return { stats, loading, error };
}
